// extracted by mini-css-extract-plugin
export default {"chip":"AceptaChip_chip__r24Cn"};